import React from 'react'

const ProfilePage = () => <div>
Coming soon...
</div>

export default ProfilePage